import Analytics from '@/utils/analytics';
import { gql, useMutation } from '@apollo/client';
import {
  SubmitProspectiveCustomerMutation,
  SubmitProspectiveCustomerMutationVariables,
} from '@/types';
import { useCallback } from 'react';

export interface SubmitProspectiveCustomerParams {
  contactEmail: string;
  contactName: string;
  contactPhoneNumber: string;
  restaurantAddress: string;
  restaurantName: string;
}

export const SUBMIT_PROSPECTIVE_CUSTOMER_MUTATION = gql`
  mutation SubmitProspectiveCustomer(
    $contactEmail: String!
    $contactName: String!
    $contactPhoneNumber: String!
    $restaurantAddress: String!
    $restaurantName: String!
  ) {
    submitProspectiveCustomer(
      contact_email: $contactEmail
      contact_name: $contactName
      contact_phone_number: $contactPhoneNumber
      restaurant_address: $restaurantAddress
      restaurant_name: $restaurantName
    ) {
      success
    }
  }
`;

export const useSubmitProspectiveCustomer = () => {
  const [submitProspectiveCustomer, { loading: isSubmitting }] = useMutation<
    SubmitProspectiveCustomerMutation,
    SubmitProspectiveCustomerMutationVariables
  >(SUBMIT_PROSPECTIVE_CUSTOMER_MUTATION, {
    context: {
      anonymous: true,
    },
    fetchPolicy: 'no-cache',
  });
  const submitProspectiveCustomerCallback = useCallback(
    async (params: SubmitProspectiveCustomerParams) => {
      const {
        contactEmail,
        contactName,
        contactPhoneNumber,
        restaurantAddress,
        restaurantName,
      } = params;
      Analytics.track('submit_prospective_customer', {
        contactEmail,
        contactName,
        contactPhoneNumber,
        restaurantAddress,
        restaurantName,
      });
      await submitProspectiveCustomer({
        variables: {
          contactEmail,
          contactName,
          contactPhoneNumber,
          restaurantAddress,
          restaurantName,
        },
      });
    },
    [submitProspectiveCustomer],
  );

  return { isSubmitting, submitProspectiveCustomerCallback };
};
